export function getHtmlDraftFont(html: string) {
  const regex = /font-family: (\w+);/g;
  const capture = regex.exec(html);
  if (capture != null && capture.length > 1) {
    return capture[1];
  }
}